export const analyticsEventNames = [
  "screen_view",
  "login_submit",
  "login_success",
  "login_error",
  "onboarding_started",
  "onboarding_step_completed",
  "onboarding_completed",
  "house_selected",
  "expense_create_started",
  "expense_created",
  "expense_create_failed",
  "search_executed",
  "search_result_opened",
  "search_empty_results",
  "push_activate_clicked",
  "push_permission_result",
  "push_device_registered",
] as const;

export type AnalyticsEventName = (typeof analyticsEventNames)[number];

export type AnalyticsPrimitive = string | number | boolean;

export type AnalyticsParams = Record<string, AnalyticsPrimitive | undefined>;

export const piiBlockedKeys = [
  "email",
  "name",
  "full_name",
  "first_name",
  "last_name",
  "query_text",
  "notes",
  "user_agent",
] as const;

const piiBlockedSet = new Set<string>(piiBlockedKeys);

export function sanitizeAnalyticsParams(
  params?: AnalyticsParams,
): Record<string, AnalyticsPrimitive> | undefined {
  if (!params) {
    return undefined;
  }
  const out: Record<string, AnalyticsPrimitive> = {};
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || piiBlockedSet.has(key)) {
      continue;
    }
    out[key] = value;
  }
  return Object.keys(out).length > 0 ? out : undefined;
}

